<template>
    <div id="customerTrialBalanceDetail">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>

        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Aged Trial Balance Detail As At</div>
                    <div class="web-action-btn btn-groups text-right">
                        <!-- Button for Clear Cache -->
                        <!-- <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data> -->
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                            <i class="fp-export"></i> Export
                        </a>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content customer-ar-report">
                        <data-table-filter-config :moduleName="'customerAgedTrialBalanceDetail'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'customerAgedTrialBalanceDetail'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="CustomerAgedTrialBalanceDetail"
                                    mode="remote"
                                    title="Aged Trial Balance Detail As At"
                                    @on-page-change="onPageChange"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-select-all="onSelectAll"
                                    @on-selected-rows-change="selectionChanged"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                        enabled: false,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                        enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                          <div v-if="props.column.field == 'pct_of_credit'">
                                              {{ amountFormat(getNum(props.formattedRow[props.column.field])) }} %
                                          </div>
                                          <div v-else>
                                              {{props.formattedRow[props.column.field]}}
                                          </div>
                                        </div>
                                    </template>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';

let msgServer;
export default {
    name: "CustomerAgedTrialBalanceDetail",
    metaInfo() {
        return {
            title: "Aged Trial Balance Detail As At | " +process.env.COPYRIGHT_NAME
        }
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
        batchProcess:0,
        batchNum:"",
        firstLoad: 0,
        permissions: [],
        cantAccessPage: "",
        userColumns:[],
        columns: [
            {
                label:'Customer Name',
                field:'customer_name',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customer Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Customer Number',
                field:'customer_code',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customer Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Doc Type',
                field:'doc_type',
                fpFieldType:"text",
                filterable:false,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Doc Type", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false
            },
            {
                label:'Invoice Number',
                field:'invoice_number',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Invoice #", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: "Order Type",
                field: "order_type",
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Order Type", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: "Invoice Amount",
                field: "invoice_amount",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Invoice Amount", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: "Invoice Date",
                field: "invoice_date",
                hidden:false,
                fpFieldType:"custom_date",
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: "Due Date",
                field: "due_date",
                hidden:false,
                fpFieldType:"custom_date",
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: "Payment Amount",
                field: "payment_amount",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Payment Amount", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                },
                // sortable:false
            },
            {
                label: "Balance Due",
                field: "balance_due",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Balance Due", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: "Current Amount",
                field: "current_amt",
                fpFieldType:"integer",
                hidden:false,
                filterable: false,
                type: 'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Current Amount", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false,
            },
            {
                label:'1-30 Days',
                field:'period_1',
                fpFieldType:"integer",
                filterable: false,
                hidden:false,
                type:'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "1-30", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false
            },
            {
                label:'31-60 Days',
                field:'period_2',
                fpFieldType:"integer",
                filterable: false,
                hidden:false,
                type:'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "31-60", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false
            },
            {
                label:'61-90 Days',
                field:'period_3',
                fpFieldType:"integer",
                filterable: false,
                hidden:false,
                type:'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "61-90", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false
            },
            {
                label:'Over 90 Days',
                field:'period_4',
                fpFieldType:"integer",
                filterable: false,
                hidden:false,
                type:'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "91+", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false
            },
            {
                label:'Avg Days',
                field:'average_days',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                // type:'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Avg Days", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label:'Sales Rep',
                field:'sales_person',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Sales Rep", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'PO Number',
                field:'po_number',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "PO Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Credit Limit',
                field:'credit_limit',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                type:'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Credit Limit", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Hold Code',
                field:'hold_code',
                fpFieldType:"text",
                filterable:false,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Hold Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false,
            },
            {
                label:'Acctg Code',
                field:'acctg_code',
                fpFieldType:"option",
                filterable:true,
                hidden:false,
                filterOptions: {
                      enabled: false, // enable filter for this column
                      placeholder: "All", // placeholder for filter input
                      filterDropdownItems: ['AR1','DP1','FIN'],
                      filterValue: '', // initial populated value for this filter
                      trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:true,
            },
            {
                label:'Phone Number',
                field:'phone_no',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Phone Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Customer Type',
                field:'customer_type',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customer Type", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Customer Order Type',
                field:'cust_order_type',
                fpFieldType:"text",
                filterable:false,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Hold Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false,
            },
            {
                label:'Customer Group Number',
                field:'cust_gnum',
                fpFieldType:"text",
                filterable:false,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customer Group Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false,
            },
            {
                label:'Customer Group Name',
                field:'cust_gname',
                fpFieldType:"text",
                filterable:false,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customer Group Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false,
            },
            {
                label:'Facility',
                field:'facility',
                fpFieldType:"option",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Facility", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Misc Customer Name Disposals',
                field:'misc_customer',
                fpFieldType:"text",
                filterable:false,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Misc Customer Name Disposals", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false,
            },
            {
                label:'As of Year',
                field:'as_of_year',
                fpFieldType:"year",
                filterable:false,
                hidden:true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "As of Year", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false,
                fpMandatory:true
            },
            {
                label:'As of Period',
                field:'as_of_period',
                fpFieldType:"period",
                filterable:false,
                hidden:true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "As of Period", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false,
                fpMandatory:true
            },
            {
                label:'Aging Date',
                field:'aging_date',
                fpFieldType:"custom_date",
                filterable:false,
                hidden:true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Aging Date", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false,
                fpMandatory:true
            }
        ],
        rows: [],
        totalRecords: 0,
        loading:false,
        action:'list'
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'customer_aged_trial_balance_detail_report') {
                        self.cantAccessPage = true;
                    }
                }
            }
        },
    },
    created: function() {
        this.serverParams.stopRequest = true;
    },
    beforeDestroy() {
        // Make sure to close the connection with the events server
        // when the component is destroyed, or we'll have ghost connections!
        msgServer.close();
    },
    mounted: function() {
        var self = this;

        self.getPermissions();

    },
    methods: {
        cancelAll: function (cancelAll) {
          this.$refs.CustomerAgedTrialBalanceDetail.unselectAllInternal();
        },
        loadList: function() {

            var self = this;
            var selectedYear = "";
            var selectedPeriod = "";
            var agingDate = "";
            if (self.serverParams.columnFilters.length > 0) {
                for(var i = 0;i < self.serverParams.columnFilters.length;i++) {
                    if (self.serverParams.columnFilters[i] != undefined) {
                        if (self.serverParams.columnFilters[i] != null) {
                            if (self.serverParams.columnFilters[i].columnId != null) {
                                if (self.serverParams.columnFilters[i].columnId.field != null) {
                                    if (self.serverParams.columnFilters[i].columnId.fpFieldType == "year") {
                                        selectedYear = self.serverParams.columnFilters[i].filterValue;
                                    }
                                    if (self.serverParams.columnFilters[i].columnId.fpFieldType == "period") {
                                        selectedPeriod = self.serverParams.columnFilters[i].filterValue;
                                    }
                                    if (self.serverParams.columnFilters[i].columnId.field == "aging_date") {
                                        agingDate = self.serverParams.columnFilters[i].filterValue;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            if (selectedYear.trim() == "" || selectedPeriod.trim() == "" || (agingDate == "" || agingDate == null)) {
                return;
            }

            var selectedRows = [];
            var data = this.$refs['CustomerAgedTrialBalanceDetail'].selectedRows;
            for ( var i = 0; i < data.length; i++ ) {
                selectedRows.push(this.$refs['CustomerAgedTrialBalanceDetail'].selectedRows[i].id)
            }

            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action:self.action,
                year:selectedYear,
                selectedAll:self.serverParams.selectedAll,
                selectedRows:selectedRows,
                agingDate:agingDate
            };

            self.firstLoad = 1;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/report/customer-aged-trial-balance-detail",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {

                      if ( self.action == "export" ||  self.action == "export_queue") {

                            if ( data.code == "201" ) {
                                alert(data.message);
                            } else {

                                if ( self.action == "export" ) {

                                    self.excel = data.content.web;
                                    var save = document.createElement("a");
                                    save.href = self.excel;
                                    save.download = data.content.web;
                                    save.target = "_blank";

                                    document.body.appendChild(save);
                                    save.click();
                                    document.body.removeChild(save);

                                } else {

                                    self.batchProcess = 1;
                                    self.batchNum = data.content;
                                }

                            }

                            self.action = "list";
                            self.loadList();
                            return;

                      } else {
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;
                      }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'aged-trial-balance-detail')
                }
            });
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/reports/CustomerAgedTrialBalanceDetail.vue